/* Package JSON Import will be here */
import React from "react";
import { Icon, Header, Segment, Table, Pagination, Button, Modal, Form, Search, Confirm } from 'semantic-ui-react';
/* Package JSON Import will be here */

/* Project Import will be here */
import Layout from "../../comman/Layout/Layout";
import { Constants } from '../../../src/config/appConstants';
// import './divisions.css';
import "../../comman/Layout/Layout.css";
import "../../assets/styles/styles.css";
import "./statusCodeList.css";
import NoResultFound from "../sharedComponent/noResultFound";
/* Project Import will be here */

const StatusCodeListComponent = props => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    return (

        <Layout>
            <Segment className="header-section">
                <Header as="h3">
                    <span className="iconify chargerOutline myiconstyle_1" data-icon="material-symbols:charger-outline" data-inline="false" ></span>
                    <span>Status Code List</span>
                </Header>
                <i aria-hidden="true"
                    onClick={() => { props.onOpenModel({ data: {} }); }}
                    style={myiconstyle} className="plus circle icon">
                </i>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                            Status Code List
                            <Search className="theader" onSearchChange={props.onStatusCodeSearch}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.statusCodeList.statusCodeDataList && props.statusCodeList.statusCodeDataList.length > 0 ? props.statusCodeList.statusCodeDataList.map(({ statusInitial, displayText, id, status }) => (
                        <Table.Row style={{ verticalAlign: 'baseline' }}>
                            <Table.Cell textAlign="center" className="tableCell">
                                <div className="forcastIcon">
                                    <Icon className="myiconstyle" edit name='trash alternate outline'
                                        onClick={() => { props.onClickDelete({ statusCodeId: id }); }}
                                    />
                                    <Icon className="myiconstyle" edit name='edit pencil'
                                        onClick={() => {
                                            props.onOpenModel({ statusCodeId: id });
                                        }}
                                    />
                                </div>
                            </Table.Cell>
                            <Table.Cell>{statusInitial} - {displayText}</Table.Cell>
                        </Table.Row>
                    )) :
                        <Table.Row>
                            <Table.Cell colSpan='2'>
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>

            <Modal closeIcon
                open={props.statusCodeList.isOpenModel}
                closeOnDimmerClick={false}
                onClose={() => { props.onCloseModel(); }}
                size='tiny'
            >
                <Modal.Header>{(props.statusCodeList.selectedValue && props.statusCodeList.selectedValue.id > 0) ? "Edit Status Code" : "Add Status Code"}</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <Form.Input required
                                    label="Initial"
                                    placeholder='Enter Initial'
                                    maxLength={3}
                                    value={props.statusCodeList.selectedValue ? props.statusCodeList.selectedValue.statusInitial : ""}
                                    onChange={(e) => { props.handleStatusCodeChange(e, { name: 'statusInitial', value: e.target.value }) }}
                                /></Form.Field>
                            <Form.Field>
                                <Form.Input required
                                    label="Description"
                                    placeholder='Enter Description'
                                    maxLength={50}
                                    value={props.statusCodeList.selectedValue ? props.statusCodeList.selectedValue.displayText : ""}
                                    onChange={(e) => { props.handleStatusCodeChange(e, { name: 'displayText', value: e.target.value }) }}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {props.statusCodeList.isEditStatusCode ?
                        <Button disabled={props.statusCodeList.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveStatusCode(props.statusCodeList.selectedValue.id)}> Update </Button> :
                        <Button disabled={props.statusCodeList.isSetButtonDisabled} type="submit" primary onClick={() => props.onSaveStatusCode()}> Save </Button>
                    }
                    <Button secondary onClick={() => props.onCloseModel()} > Back </Button>
                </Modal.Actions>
            </Modal>
            <Confirm
                closeIcon
                open={props.statusCodeList.isDeleteConfirm}
                content="Are you sure? Do you want to delete this Status Code?"
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.onCancelDelete(); }}
                onConfirm={() => { props.onConfirmDelete(); }}
            />
            {props.statusCodeList.statusCodeDataList && props.statusCodeList.statusCodeDataList.length > 0 &&
                <Pagination floated="right"
                    activePage={props.statusCodeList.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.statusCodeList.pagination.totalCount} />
            }
        </Layout >
    );
}

export default StatusCodeListComponent;

StatusCodeListComponent.displayName = "StatusCodeListComponent";